import { composeStateMachine } from '@opengov/compose-app/core/module';
import { IReportConfiguration } from '@opengov/reporting-types';

import { SummaryTableRecord } from './records';

export const summaryTableState = composeStateMachine('report-summary-table', SummaryTableRecord(), (compose) => ({
  setDataAndConfig: compose.action(
    (state, payload: { data: any[]; columns: any[]; reportConfiguration: IReportConfiguration }) =>
      state
        .set('data', payload.data)
        .set('reportConfiguration', payload.reportConfiguration)
        .set('columns', payload.columns)
  ),
  resetState: compose.payloadlessAction((state) => state.clear())
}));

export const {
  actions: summaryTableActions,
  actionCreators: summaryTableActionCreators,
  reducer: summaryTableReducer,
  selector: summaryTableSelector
} = summaryTableState;
